<template>
  <div>
    <ul>
      <li v-for="(one, $index) in list" :key="$index" 
        :class="$index === 0 || $index === 1 || $index === 2 ? 'c-list-li-box' : ''"
        :style="$index === 1 ? {margin: '.123rem .105rem .041rem .105rem'} : ''">
        <div v-if="$index === 1 && list.length >= 2" class="c-topThreeBox c-top-box1">
          <img :src="first">
          <img :src="one.portrait || defaultAvatar" class="c-avatar-wh1">
          <p class="c-user-info-ranking c-avatar1" v-text="1"></p>
          <p class="c-user-info-name">{{one.nickName}}</p>
          <p class="c-user-info-score">{{one.points | getPointValue}}</p>
        </div>
        <div v-else-if="$index === 0 && list.length < 2" class="c-topThreeBox c-top-box1">
          <img :src="first">
          <img :src="one.portrait || defaultAvatar" class="c-avatar-wh1">
          <p class="c-user-info-ranking c-avatar1" v-text="1"></p>
          <p class="c-user-info-name">{{one.nickName}}</p>
          <p class="c-user-info-score">{{one.points | getPointValue}}</p>
        </div>
        <div v-else-if="$index === 0 && list.length >= 2" class="c-topThreeBox c-top-box2">
          <img :src="second">
          <img :src="one.portrait || defaultAvatar" class="c-avatar-wh2">
          <p class="c-user-info-ranking c-avatar2" v-text="2"></p>
          <p class="c-user-info-name">{{one.nickName}}</p>
          <p class="c-user-info-score">{{one.points | getPointValue}}</p>
        </div>
        <div v-else-if="$index === 2 && list.length >= 2" class="c-topThreeBox c-top-box3">
          <img :src="third">
          <img  :src="one.portrait || defaultAvatar" class="c-avatar-wh3">
          <p class="c-user-info-ranking c-avatar3" v-text="3"></p>
          <p class="c-user-info-name">{{one.nickName}}</p>
          <p class="c-user-info-score">{{one.points | getPointValue}}</p>
        </div>
        <div v-else class="c-not-top">
          <p>{{$index + 1}}</p>
          <div>
            <img :src="one.portrait || defaultAvatar">
            <span class="c-not-top-name">{{one.nickName || '无'}}</span>
            <span class="c-not-top-score">{{one.points | getPointValue}}</span>
          </div>
        </div>
      </li>
      <li style="width: 100%;height: 0.6562rem;padding: 0;margin: 0;"></li>
    </ul>
    <div class="c-personal-info">
      <p>{{ !me.myRank ? '无' : me.myRank > 50 ? '无' :  me.myRank }}</p>
      <div>
        <img :src="me.myPortrait || defaultAvatar">
        <span class="c-personal-name">{{me.myNickname || '无'}}</span>
        <span class="c-personal-score">{{me.myPoints | getPointValue}}</span>
      </div>
    </div>
  </div>
</template>
  
<script>
import defaultAvatarPic from '@/assets/images/avatar_default_boy.png';
import first from '@/assets/images/firstCrown.svg';
import second from '@/assets/images/secondCrown.svg';
import third from '@/assets/images/thirdCrown.svg';

export default {
  name: 'WeekList',
  data() {
    return {
      list: [],
      defaultAvatar: defaultAvatarPic,
      first: first,
      second: second,
      third: third,
      me: {}
    }
  },
  filters: {
    getPointValue(val) {
      let pointVal = val ? val : 0;
      return pointVal > 10000 ? (pointVal / 10000).toFixed(2) + '万' : pointVal;
    }
  },
  methods: {
    getAllData(pkg) {
      let data = JSON.parse(Android.getRankInfo(pkg));
      let list;
      if(data.rankList && data.rankList.length > 0) {
        list = data.rankList.length > 50 ? data.rankList.splice(0, 50) : data.rankList;
      }
      Object.assign(this.me, {
        myRank: data.myRank,
        myPoints: data.myPoints,
        myPortrait: data.myPortrait,
        myNickname: data.myNickname
      })
      if(list && list.length > 0) {
        if(list.length >= 2) {
          let secondPerson = list[1];
          list.splice(1, 1);
          list.unshift(secondPerson);
          this.list.push(...list);
        }else {
          this.list.push(...list);
        }
      }
    }
  },
  mounted() {
    let getPackageName = Android.getRaiseMoneyFromH5()
    this.getAllData(getPackageName);
  },
}
</script>
  
<style lang="less" scoped>
.c-list-li-box {
  display: inline-block;
  text-align: center;
}
/* 前三条 */
.c-topThreeBox {
  color: #fff;
  border-radius: .041rem;
  text-align: center;
}
.c-topThreeBox > .c-user-info-ranking {
  border-radius: 50%;
  border: .0225rem solid #fff;
  color: #fff;
  text-align: center;
  margin: 0 auto;
  position: relative;
}
.c-topThreeBox > img {
  display: inline-block;
}
.c-avatar1 {
  background: #ff9500;
  width: .273rem;
  height: .273rem;
  font-size: .187rem;
  line-height: .243rem;
  top: -.206rem;
}
.c-avatar2 {
  background: #7e8288;
  width: .255rem;
  height: .255rem;
  font-size: .1575rem;
  line-height: .225rem;
  top: -.187rem;
}
.c-avatar3 {
  background: #bf7363;
  width: .255rem;
  height: .255rem;
  font-size: .157rem;
  line-height: .225rem;
  top: -.187rem;
}
.c-top-box1 {
  margin-left:0.04rem;
  width: 1.147rem;
  padding-top: .165rem;
  padding-bottom: .131rem;
  background: -webkit-linear-gradient(#ff5b36, #fce763);
  background: -o-linear-gradient(#ff5b36, #fce763);
  background: -moz-linear-gradient(#ff5b36, #fce763);
  background: linear-gradient(#ff5b36, #fce763);
}
.c-top-box2 {
  width: 1.03rem;
  margin-left:0.14rem;
  padding-top: .165rem;
  padding-bottom: .123rem;
  background: -webkit-linear-gradient(#7d8187, #eaeaea);
  background: -o-linear-gradient(#7d8187, #eaeaea);
  background: -moz-linear-gradient(#7d8187, #eaeaea);
  background: linear-gradient(#7d8187, #eaeaea);
}
.c-top-box3 {
  width: 1.03rem;
  padding-top: .165rem;
  padding-bottom: .123rem;
  background: -webkit-linear-gradient(#8a4a3c, #f0d5b7);
  background: -o-linear-gradient(#8a4a3c, #f0d5b7);
  background: -moz-linear-gradient(#8a4a3c, #f0d5b7);
  background: linear-gradient(#8a4a3c, #f0d5b7);
}
.c-top-box1 > img:first-child {
  width: 0.427rem;
  height: .251rem;
  display: block;
  margin: 0 auto;
}
.c-top-box2 > img:first-child {
  width: .3338rem;
  height: .2025rem;
  display: block;
  margin: 0 auto;
}
.c-top-box3 > img:first-child {
  width: .3338rem;
  height: .2025rem;
  display: block;
  margin: 0 auto;
}
img.c-avatar-wh1 {
  width: 0.7688rem;
  height: 0.7688rem;
  border-radius: 50%;
  margin-top: -.00375rem;
  border: .03rem solid #ffdb47;
}
img.c-avatar-wh2 {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  margin-top: -.00375rem;
  border: .03rem solid #e9e9e9;
}
img.c-avatar-wh3 {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  margin-top: -.00375rem;
  border: .03rem solid #f0d5b7;
}
.c-user-info-name {
  font-size: .123rem;
  line-height: .123rem;
  color: #fff;
  margin-top: -.112rem;
  font-weight: 400;
}
.c-user-info-score {
  font-size: .146rem;
  line-height: .146rem;
  color: #fff;
  margin-top: 0.056rem;
  font-weight: 500;
}
/* 除了前三条 */
.c-not-top {
  width: 3.416rem;
  margin: 0 .165rem;
  text-align: left;
}
.c-not-top > p,
.c-not-top > div {
  display: inline-block;
  vertical-align: middle;
}
.c-not-top > p {
  color: #999;
  font-size: .157rem;
  line-height: .195rem;
  width: .1763rem;
  height: .1875rem;
  text-align: center;
}
.c-not-top > div {
  margin-left: .105rem;
  border-bottom: 1px solid #e9e9e9;
  padding: .093rem 0;
  width: 2.925rem;
}
.c-not-top > div > img {
  width: 0.4163rem;
  height: 0.4163rem;
  border-radius: 50%;
  vertical-align: middle;
}
.c-not-top > div > span {
  vertical-align: middle;
  padding-left:0.04rem;
}
.c-not-top-name {
  color: #666;
  font-size: .123rem;
  line-height: .123rem;
  font-weight: 400;
}
.c-not-top-score {
  float: right;
  text-align: right;
  color: #666;
  font-size: .146rem;
  line-height: 0.495rem;
  font-weight: 500;
}
/* 个人信息区域 */
.c-personal-info {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: .0825rem .165rem;
  background: rgba(0, 0, 0, .75);
  color: #fff;
  text-align: left;
}
.c-personal-info img {
  width: 0.41625rem;
  height: 0.41625rem;
  border-radius: 50%;
  margin-left: .22875rem;
  vertical-align: middle;
}
.c-personal-info > p {
  font-size: .1575rem;
  color: #999;
  line-height: .2175rem;
  width: .1763rem;
  height: .1875rem;
  display: inline-block;
  vertical-align: middle;
}
.c-personal-info > div {
  display: inline-block;
  vertical-align: middle;
  width: 3.15rem;
}
span.c-personal-name {
  font-size: .1575rem;
  line-height: .1575rem;
  vertical-align: middle;
  font-weight: 500;
  margin-left:0.04rem;
}
span.c-personal-score {
  font-size: .14625rem;
  line-height: 0.4875rem;
  font-weight: 500;
  float: right;
}
</style>